import { action, computed, observable, reaction, makeObservable } from 'mobx';
import { X5LessonSnapshot, X8BlockSnapshot } from '../../../domain';
import { Disposers, HttpPromiseState, logger } from '../../../lib/helpers';
import { EssayViewModel } from '../EssayModels';
import { EssayLoaders } from '../EssayLoaders';

export class EssayStudentSceneStore {
  @observable.ref
  essayLoader: HttpPromiseState<EssayViewModel> | null;

  private readonly disposers = new Disposers();

  constructor(readonly essayId: number) {
    makeObservable(this);
    this.essayLoader = null;
    this.setup();
  }

  private setup() {
    this.disposers.add(
      reaction(
        () => this.essayLoader?.value,
        this.onEssayLoaded),
    );
  }

  @action
  loadEssay = () => {
    if (this.essayLoader?.isPending)
      return;
    this.essayLoader = EssayLoaders.getEssay(this.essayId);
  };

  submitEssay = (essayId: number, text: string) => {
    return EssayLoaders.studentSubmit(essayId, text);
  }

  saveEssay = (essayId: number, text: string) => {
    return EssayLoaders.studentSave(essayId, text);
  }

  @action
  private onEssayLoaded = () => {
    const state = this.essayLoader;
    if (state === null || !state.isResolved)
      return;
  };

  dispose() {
    this.disposers.dispose();
  }
}
